import { Box } from '@material-ui/core';

import BaseTypography from 'src/legacy/components/Text/BaseTypography';
import { BrandAvatar } from 'src/legacy/components/UI/Avatars/BrandAvatar';

import { OnboardingFormCard } from '../OnboardingFormCard';
import {
  MfaFormProps,
  OnboardingForgotPasswordForm,
} from '../OnboardingForms/OnboardingForgotPasswordForm';

import { OnboardingAuthLayoutProps } from './OnboardingAuthLayout';

type OnboardingForgotPasswordPageProps = OnboardingAuthLayoutProps &
  MfaFormProps;

export const OnboardingForgotPasswordPage = ({
  onAuthComplete,
  onMfaRequired,
}: OnboardingForgotPasswordPageProps) => (
  <OnboardingFormCard>
    <BrandAvatar />
    <Box mt={1.5} mb={5} textAlign="center" px={{ xs: 2, sm: 0 }}>
      <BaseTypography fontType="18Medium">Reset your password</BaseTypography>
    </Box>
    <Box mt={-2.5}>
      <OnboardingForgotPasswordForm
        onAuthComplete={onAuthComplete}
        onMfaRequired={onMfaRequired}
      />
    </Box>
  </OnboardingFormCard>
);
